const PaymentOptions = [
  {
    type: 'Stripe',
    value: 'stripe',
    icon: '/assets/provider-icons/stripe.png',
    id: 1,
  },
  {
    type: 'Lemon Squeezy',
    value: 'lemon_squeeze',
    icon: '/assets/provider-icons/lemon.png',
    id: 3,
  },
  {
    type: 'Pabbly',
    value: 'pabbly',
    icon: '/assets/provider-icons/pabbly.png',
    id: 2,
  },
  /*{
    type: 'Paystack',
    value: 'pay_stack',
    icon: '/assets/provider-icons/paystack.png',
  },*/
]

export default PaymentOptions
